export default "__VITE_ASSET__723aaa8d__"